"use strict";
var assign = require("./Object.assign");
var invariant = require("fbjs/lib/invariant");
var autoGenerateWrapperClass = null;
var genericComponentClass = null;
var tagToComponentClass = {};
var textComponentClass = null;
var ReactNativeComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function(componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function(componentClass) {
    textComponentClass = componentClass;
  },
  // This accepts a keyed object with classes as values. Each key represents a
  // tag. That particular tag will use this class instead of the generic one.
  injectComponentClasses: function(componentClasses) {
    assign(tagToComponentClass, componentClasses);
  }
};
function getComponentClassForElement(element) {
  if (typeof element.type === "function") {
    return element.type;
  }
  var tag = element.type;
  var componentClass = tagToComponentClass[tag];
  if (componentClass == null) {
    tagToComponentClass[tag] = componentClass = autoGenerateWrapperClass(tag);
  }
  return componentClass;
}
function createInternalComponent(element) {
  !genericComponentClass ? process.env.NODE_ENV !== "production" ? invariant(false, "There is no registered component for the tag %s", element.type) : invariant(false) : void 0;
  return new genericComponentClass(element.type, element.props);
}
function createInstanceForText(text) {
  return new textComponentClass(text);
}
function isTextComponent(component) {
  return component instanceof textComponentClass;
}
var ReactNativeComponent = {
  getComponentClassForElement,
  createInternalComponent,
  createInstanceForText,
  isTextComponent,
  injection: ReactNativeComponentInjection
};
module.exports = ReactNativeComponent;
